import  { useCallback, useEffect, useState, useRef } from "react";
import useColumn from "../../../utils/customHooks/useColumns";
import { useNavigate } from "react-router-dom";
import usePageState from "../../../utils/customHooks/usePageState";
import { STAUTES } from "../../../utils/constant";
import { GET_ALL_ASSIGNED_RAP, DELETE_ASSIGN_RAP } from "../../../utils/services/apiPath";
import { deleteApi, postApi } from "../../../utils/services";
import { successToast, errorToast } from "../../../utils/toastHelper";
import { useTheme } from "../../ContextStore/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout, userSelector } from "../../store/features/auth/authSlice";
import logo from "../../Assets/Icons/logo.png";
import logoWhite from "../../Assets/Icons/logo-white.png";
import menuopen from "../../Assets/Icons/menu-open.png";
import menuclose from "../../Assets/Icons/menu-close.png";
import NotificationIcon from "../../Assets/IconComponents/Notification";
import { headerMenus } from "../../../utils/MenusConfig";
import HelpMenu from "../../Components/Header/HelpMenu";
import { ProGrid, NameCell, DeleteCell, Layout } from "@proscore-ai/proscore-ui-library";
import useCsvExport from "../../../utils/useCsvExporter";


const getRedirectUrl = params => {
  return `/assign-rapInfo/${params.id}`;
};

export default function AssignRapInfo() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const [popOverOpen, setPopOverOpen] = useState(false);
  const ref = useRef(null);
  const userData = useSelector(userSelector);
  const dispatch = useDispatch();

  const handleTabClick = tab => {
    navigate(`${tab.to}`);
  };
  const handleMenuOpen = () => setMenuOpen(!menuOpen);

  const onLogout = () => {
    dispatch(handleLogout());
  };

  const manageAccount = () => {
    setPopOverOpen(false);
  };

  const handleHome = () => {
    navigate("/clients");
  };
  const {
    currentPage,
    pageSize,
    data: assignRapInfoData,
    rowCount,
    status,
    sortModel,
    searchString,
    setPageState,
    setPagination,
    setStatus,
    setSortModel,
    setSearchString
  } = usePageState();
  const columns = useColumn(
    [
      {
        field: "approvedJobTitle",
        headerName: "Approved Ocupation Title",
        renderCell: params => <NameCell params={params} getRedirectUrl={getRedirectUrl} />
      },
      {
        field: "category",
        headerName: "Category"
      },
      {
        field: "companyName",
        headerName: "Client"
      },
      {
        field: "assignRAPInfoGuid",
        headerName: "Actions",
        isDeleteColumn: true,
        disableExport: true,
        width: 80,
        renderCell: params => <DeleteCell title={"Delete Labor Classification Title"} params={params} onDelete={onDelete} />
      }
    ],
    true
  );

  const addButtonAction = () => {
    navigate(`/assign-rapInfo/add`);
  };

  const onDelete = async id => {
    const { error } = await deleteApi(DELETE_ASSIGN_RAP, { params: { assignRapId: id } });
    if (error) return errorToast(error);
    getAssignRapInfo();
    successToast("Labor Classification Title deleted successfully.");
  };

  const getAssignRapInfo = useCallback(async () => {
    setStatus(STAUTES.LOADING);
    const payload = {
      pageIndex: searchString ? 1 : currentPage + 1,
      pageSize: pageSize,
      searchString: searchString,
      orderByAscending: true,
      ...sortModel
    };
    const { data, totalRecords, error } = await postApi(GET_ALL_ASSIGNED_RAP, payload);
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    setPageState(prevPageInfo => ({ ...prevPageInfo, data: data || [], rowCount: totalRecords }));
  }, [currentPage, pageSize, sortModel, searchString, setPageState, setStatus]);

  const handleDownloadCSV = useCsvExport({
    api: GET_ALL_ASSIGNED_RAP,

    getPayload: () => {
      const activeSort = sortModel?.[0] || { field: "approvedJobTitle", sort: "asc" };

      return {
        pageIndex: 1,
        pageSize: rowCount || 10000,
        searchString,
        orderByAscending: activeSort.sort === "asc"
      };
    },

    mapData: data =>
      data.map(item => ({
        "Approved Occupation Title": item.approvedJobTitle || "",
        "Category": item.category || "",
        "Client": item.companyName || ""
      })),

    fileName: "AssignRapInfoList.csv"
  });

  useEffect(() => {
    getAssignRapInfo();
  }, [getAssignRapInfo]);

  return (
    <Layout
      theme={theme}
      user={{
        userName: userData?.userName,
        email: userData?.email,
        avatar: userData?.avatar
      }}
      onLogout={onLogout}
      onTabClick={handleTabClick}
      onLogoClick={handleHome}
      logo={logo}
      logoWhite={logoWhite}
      menuOpenIcon={menuopen}
      menuCloseIcon={menuclose}
      menuTabs={headerMenus}
      NotificationIcon={NotificationIcon}
      HelpComponent={HelpMenu}
    >
      <ProGrid
        title="Assign Rap Info"
        columns={columns}
        loading={status === STAUTES.LOADING}
        rows={assignRapInfoData}
        searchMode={!!searchString}
        searchModel={{ defaultValue: searchString, handleDebounce: setSearchString }}
        addButtonLabel="+ Add Assign Rap Info"
        addButtonAction={addButtonAction}
        hideAddButton={false}
        hideExport={false}
        options={{
          getRowId: row => row.assignRAPInfoGuid,
          rowCount: rowCount,
          paginationMode: "server",
          paginationModel: { pageSize: pageSize, page: currentPage },
          onPaginationModelChange: setPagination,
          sortingMode: "server",
          onSortModelChange: setSortModel
        }}
        exportAction={handleDownloadCSV}
      />
    </Layout>
  );
}
